// extracted by mini-css-extract-plugin
export default {"container":"De1MzN","stacked":"nIrkeO","withDivider":"gZunol"};